<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>პროდუქტი ქართულ ბაზარზე - ლიზინგი სკუტერებისთვის</h1>
    <h6>ივნისი 2021</h6>
    <br />
    <p class="stroked-header blue">მარტივი გადაადგილება.</p>
    <p>
      უკვე კარგად ჟღერს, არა?
    </p>

    <p>
      დღეს საცობებით გადატვირთულ ქალაქში ადამიანებისთვის ცხოვრების გამარტივების ერთ-ერთი საუკეთესო საშუალება სკუტერის
      შეძენაა.
    </p>

    <p class="stroked-header purple">მარტივი დაფინანსება.</p>

    <p style="padding-top: 0">
      ეს კი, უკვე რაღაც იმედისმომცემი და ხელმისაწვდომია, არა?
    </p>

    <p>
      ქართულ ბაზარზე სრულიად ახალი პროდუქტი გამოჩნდა, რომელიც შეიქმნა მარტივი გადაადგილების, ეკომეგობრულობისა და
      ეკონომიურობის იდეით — აქ, ახლა უკვე შეგიძლია სკუტერი ლიზინგით შეიძინო!
    </p>

    <img src="../../../../assets/blog/scooters/img1.jpg" alt="" />

    <p>
      თიბისი ლიზინგი, როგორც მწვანე პროექტების მხარდამჭერი, მუდმივად ცდილობს გააფართოოს თავისი საქმიანობის არეალი და
      მომხმარებელს შესთავაზოს ყველა ის აქტივი, რომელიც გარემოზე ზრუნვას უკავშირდება. სწორედ ამიტომ, მომხმარებლების
      ინტერესიდან გამომდინარე, შეიქმნა პროდუქტი, რომელიც აფინანსებს მოტოტექნიკას, კერძოდ - სკუტერებსა და მოტოციკლებს.
    </p>

    <p>
      ის სკუტერები, რომლებიც მხოლოდ შიდა განვადებით იყო ხელმისაწვდომი, რადგან სხვა საშუალება ოფიციალურად არ არსებობდა,
      დღეს უკვე შეგიძლია ლიზინგით შეიძინო.
    </p>

    <img src="../../../../assets/blog/scooters/img2.jpg" alt="" />

    <p>
      <i class="subhead"><b style="color: #9461f7">რა ტიპის მოტოტექნიკის შეძენა შემიძლია ლიზინგით</b></i
      ><br /><br />

      ლიზინგით შეგიძლია შეიძინო სკუტერები და მოტოციკლები. ამ ეტაპზე, ლიზინგით შეიძენ მხოლოდ ახალ მოტოტექნიკას. მიზეზი,
      რატომაც აქცენტს თანამედროვე სტანდარტების მქონე პროდუქციაზე ვაკეთებთ, არის ის, რომ მათ გამონაბოლქვი მეორადებისგან
      განსხვავებით გაცილებით ნაკლები აქვს.
    </p>

    <p>
      <i class="subhead"><b style="color: #14e2bc">რა უნდა იცოდე ლიზინგის პირობების შესახებ</b></i
      ><br /><br />

      პირველი კითხვა, რაც ფინანსური პროდუქტის შესახებ ჩნდება, მისი შესაძლო ვადა და პროცენტის მოცულობაა, ეს კი,
      დამოკიდებულია თავად მომხმარებლის საკრედიტო ისტორიაზე. თუმცა, ლიზინგის ერთ-ერთი უპირატესობა სწორედ ისაა, რომ
      დამტკიცების პროცესში შემოსავლების დეტალური შესწავლა არ ხდება.
    </p>

    <p>
      სკუტერის შემთხვევაში, 15 000 ლარამდე ღირებულების მოტოტექნიკის ლიზინგით დასაფინანსებლად, პირადობის დამადასტურებელი
      და მართვის მოწმობა გეყოფა.
    </p>

    <p>
      შემოსავლების დამადასტურებელი საბუთის წარმოდგენა დაგჭირდება მხოლოდ მაშინ, როდესაც სასურველი მოტოტექნიკის ღირებულება
      15 000 ლარზე მეტი იქნება.
    </p>

    <p>
      სკუტერის ლიზინგით შეძენისას, შეგიძლია გადასახადი დაფარო 3 თვიდან 2 წლამდე პერიოდში.
    </p>

    <img src="../../../../assets/blog/scooters/img3.jpg" alt="" />

    <p>
      <i class="subhead"><b style="color: #2748bf">სპეციალური ფასები</b></i
      ><br /><br />

      იქიდან გამომდინარე, რომ ჩვენ ვთანამშრომლობთ მოტოტექნიკის სხვადასხვა მომწოდებელ კომპანიასთან, პერიოდულად,
      სკუტერებზე ლიზინგისგან სპეციალურ ფასებსა და პირობებს მიიღებ.
    </p>

    <p>
      მოტოტექნიკის ლიზინგით შეძენას თუ გადაწყვეტ, პირველ ეტაპზე შენ გიწევს საერთო ღირებულების მხოლოდ 20%-ის გადახდა,
      გაცემის საკომისიო კი 0%-ს შეადგენს.
    </p>

    <p>
      ასე რომ, თუ 21-65 წლამდე ხარ, A კატეგორიის მართვის მოწმობა ხელში გიჭირავს და ქალაქში გადაადგილება სწრაფად, ბევრი
      დანახარჯის გარეშე გსურს, უკვე იცი დაფინანსებისთვის ვის მიმართო.
    </p>

    <p>დაგვიტოვე საკონტაქტო ინფორმაცია - <a href="https://bit.ly/3d92dpp" target="_blank">https://bit.ly/3d92dpp</a></p>
    <p>დაგვირეკე - <span style="color: #0f437f">2 122 777</span></p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>Product on the Georgian Market - Scooter Leasing</h1>
    <h6>June 2021</h6>
    <br />
    <p class="stroked-header blue">Easy Mobility.</p>
    <p>
      Sounds good, doesn’t it?
    </p>

    <p>
      Today, one of the best ways to simplify life for people in a city congested with traffic jams is to purchase a
      scooter.
    </p>

    <p class="stroked-header purple">Easy Financing.</p>

    <p style="padding-top: 0">
      This already sounds hopeful and accessible, right?
    </p>

    <p>
      A completely new product has appeared on the Georgian market, created with the idea of easy mobility,
      eco-friendliness, and economy in mind — here, now you can purchase a scooter via leasing!
    </p>

    <img src="../../../../assets/blog/scooters/img1.jpg" alt="" />

    <p>
      As a supporter of green projects, TBC Leasing constantly strives to expand its activities and offer customers all
      assets related to environmental care. That's why, in response to customer interest, a product was created to
      finance motorized vehicles, specifically scooters and motorcycles.
    </p>

    <p>
      Scooters, which were previously only available through internal installment plans because no other official method
      existed, can now be purchased through leasing.
    </p>

    <img src="../../../../assets/blog/scooters/img2.jpg" alt="" />

    <p>
      <i class="subhead"><b style="color: #9461f7">What type of motorized vehicle can I buy via leasing?</b></i
      ><br /><br />

      You can purchase scooters and motorcycles via leasing. At this stage, leasing is available only for new motorized
      vehicles. The reason we focus on products with modern standards is that they emit much less pollution compared to
      used ones.
    </p>

    <p>
      <i class="subhead"><b style="color: #14e2bc">What should you know about the leasing terms?</b></i
      ><br /><br />

      The first question that arises about financial products is usually about the potential duration and interest
      rates. These depend on the customer’s credit history. However, one of the advantages of leasing is that a detailed
      review of income is not conducted during the approval process.
    </p>

    <p>
      For a scooter, to finance a motorized vehicle worth up to 15,000 GEL, just your identity card and driver’s license
      will be enough.
    </p>

    <p>
      You will need to provide proof of income only if the desired vehicle exceeds 15,000 GEL in value.
    </p>

    <p>
      When purchasing a scooter through leasing, you can pay the installments over a period of 3 months to 2 years.
    </p>

    <img src="../../../../assets/blog/scooters/img3.jpg" alt="" />

    <p>
      <i class="subhead"><b style="color: #2748bf">Special Prices</b></i
      ><br /><br />

      Since we collaborate with various motorized vehicle suppliers, periodically, you will receive special prices and
      conditions on scooters through leasing.
    </p>

    <p>
      If you decide to purchase a motorized vehicle via leasing, initially, you will need to pay only 20% of the total
      cost, and the issuance commission is 0%.
    </p>

    <p>
      So, if you're between 21-65 years old, have a Category A driver’s license, and want to move around the city
      quickly and without high expenses, you already know who to contact for financing.
    </p>

    <p>
      Leave us your contact information - <a href="https://bit.ly/3d92dpp" target="_blank">https://bit.ly/3d92dpp</a>
    </p>
    <p>Call us at - <span style="color: #0f437f">2 122 777</span></p>
  </div>
</ng-container>
